export interface AdditionalDetailsType {
  firstPaymentFee?: number | null;
  firstPaymentDate?: string | null;
  secondPaymentFee?: number | null;
  secondPaymentDate?: string | null;
  tuitionFee?: number | null;
  ancillaryFee?: number | null;
  additionalNotes?: string | null;
}

export const STEPS = {
  STEP1: 1,
  STEP2: 2,
  STEP3: 3,
} as const;

export enum OfferType {
  PRE_OFFER = 'PRE_OFFER',
  FINAL_OFFER = 'FINAL_OFFER',
  WAITLIST = 'WAITLIST',
}
